import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDiscardUserInvitationArgs,
  BackendUserInvite,
} from 'src/types/backend';

import { USER_INVITE_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation DiscardUserInvitation($token: String!) {
    discardUserInvitation(token: $token) {
      ...UserInvite
    }
  }
  ${USER_INVITE_FRAGMENT}
`;

type Variables = BackendMutationDiscardUserInvitationArgs;
type Result = BackendUserInvite;

export const discardUserInvitation = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
